(() => {
  const configElement = document.getElementById('tfc-matching-thread-config');
  if (!configElement) return;
  const messages = JSON.parse(configElement.textContent);
  const root = window.Shopify.routes.root;
  let busy = false;
  const propertiesKey = properties => JSON.stringify(Object.entries(Array.isArray(properties) ? Object.fromEntries(properties) : (properties || {})).sort(([a], [b]) => a.localeCompare(b)));
  const isMatch = (item, input) => String(item.variant_id) === input.dataset.threadVariant &&
    String(item.properties?._tfc_fabric_variant) === input.dataset.fabricVariant &&
    item.properties?._tfc_fabric_properties === input.dataset.fabricProperties;
  const request = async (path, payload) => {
    const response = await fetch(root + path, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...(payload ? {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload)} : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || messages.error);
    return data;
  };
  const lock = () => {
    const saved = [];
    document.querySelectorAll('.js-cart-form button,.js-cart-form input,.js-cart-form textarea,.js-cart-form select').forEach(control => {
      saved.push([control,control.disabled]);
      control.disabled = true;
    });
    return () => saved.forEach(([control,disabled]) => {if(control.isConnected) control.disabled = disabled;});
  };
  const refresh = async cart => {
    const response = await fetch(root + 'cart/?view=ajax', {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error(messages.refresh_error);
    const source = new DOMParser().parseFromString(await response.text(),'text/html');
    const content = source.querySelector('template[data-html="content"]');
    if (!content) throw new Error(messages.refresh_error);
    document.querySelectorAll('.js-ajax-cart-content').forEach(container => {container.innerHTML = content.innerHTML;});
    document.querySelectorAll('.js-cart-count').forEach(counter => {counter.textContent = cart.item_count;});
    const themeConfig = JSON.parse(document.getElementById('cart-config').textContent);
    document.querySelectorAll('.js-cart-accordion').forEach(accordion => {
      window.theme.Helpers.Accordion(accordion,'.tlink.has_sub_menu a','.accordion-content.sub');
      window.theme.Helpers.Accordion(accordion,'.tlink2.has_sub_menu a','.accordion-content2.sub');
    });
    window.Shopify.theme.ajaxCart.cartEvents(themeConfig);
    if (document.querySelectorAll('#dynamic-checkout-cart').length > 1) document.querySelectorAll('#dynamic-checkout-cart')[1].remove();
  };
  document.addEventListener('click', event => {
    if (busy && event.target.closest('.js-cart-form,.additional-checkout-buttons')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },true);
  document.addEventListener('submit', event => {
    if (busy && event.target.matches('.js-cart-form')) {event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-tfc-thread-toggle]');
    if (!input) return;
    event.stopPropagation();
    if (busy) return;
    const wanted = input.checked;
    const cartContainer = input.closest('.js-ajax-cart-content');
    const option = input.closest('[data-tfc-thread-option]');
    const status = option.querySelector('[data-tfc-thread-status]');
    busy = true;
    const unlock = lock();
    option.setAttribute('aria-busy','true');
    status.textContent = messages.updating;
    let cartChanged = false;
    try {
      const cart = await request('cart.js');
      const parent = cart.items.find(item => String(item.variant_id) === input.dataset.fabricVariant && propertiesKey(item.properties) === propertiesKey(JSON.parse(input.dataset.fabricProperties)));
      if (!parent && wanted) throw new Error(messages.fabric_missing);
      const matches = cart.items.filter(item => isMatch(item,input));
      if (wanted && !matches.length) {
        const fabricOption = input.dataset.fabricOption === 'Default Title' ? '' : input.dataset.fabricOption;
        await request('cart/add.js', {items:[{id:Number(input.dataset.threadVariant),quantity:1,properties:{
          [messages.fabric_property]:input.dataset.fabricTitle,
          ...(fabricOption ? {[messages.option_property]:fabricOption} : {}),
          _tfc_fabric_variant:input.dataset.fabricVariant,
          _tfc_fabric_properties:input.dataset.fabricProperties
        }}]});
        cartChanged = true;
      } else if (!wanted) {
        for (const match of matches) {await request('cart/change.js',{id:match.key,quantity:0});cartChanged = true;}
      }
      const updatedCart = await request('cart.js');
      await refresh(updatedCart);
      const toggles = [...document.querySelectorAll('[data-tfc-thread-toggle]')].filter(control => control.dataset.fabricVariant === input.dataset.fabricVariant && control.dataset.fabricProperties === input.dataset.fabricProperties);
      toggles.forEach(control => {control.closest('[data-tfc-thread-option]').querySelector('[data-tfc-thread-status]').textContent = wanted ? messages.added : messages.removed;});
      const visibleToggle = toggles.find(control => cartContainer?.contains(control)) || toggles.find(control => control.getClientRects().length);
      if (visibleToggle) visibleToggle.focus({preventScroll:true});
    } catch(error) {
      if (cartChanged) {
        window.location.assign(root + 'cart');
        return;
      }
      input.checked = !wanted;
      status.textContent = error.message || messages.error;
    } finally {
      option.removeAttribute('aria-busy');
      unlock();
      busy = false;
    }
  });
})();
